const lockStates = new WeakMap();

function getLockState(documentRef) {
  let state = lockStates.get(documentRef);
  if (!state) {
    state = { count: 0, originalOverflow: '' };
    lockStates.set(documentRef, state);
  }
  return state;
}

export function createBodyOverflowLock(documentRef = globalThis.document) {
  let acquired = false;

  function acquire() {
    if (acquired || !documentRef?.body?.style) return;

    const state = getLockState(documentRef);
    if (state.count === 0) {
      state.originalOverflow = documentRef.body.style.overflow;
      documentRef.body.style.overflow = 'hidden';
    }
    state.count += 1;
    acquired = true;
  }

  function release() {
    if (!acquired || !documentRef?.body?.style) return;

    const state = getLockState(documentRef);
    state.count -= 1;
    acquired = false;

    if (state.count === 0) {
      documentRef.body.style.overflow = state.originalOverflow;
      lockStates.delete(documentRef);
    }
  }

  return { acquire, release, dispose: release };
}
